const Wizard = ({children}) => {
    return (
        <div class="main-content__steps">
            {children}
        </div>
    );
};

export default Wizard;
